import { ACOMPANHAMENTO_TERRITORIO_PATH } from 'components/layout/SideMenu/SideMenuItems'

export const getCallbackTabByString = (tab: string) =>
  ['informacoes', 'visitas', 'familias'].includes(tab) ? tab : 'informacoes'

export const getVisualizacaoImovelCallbackUrl = (imovelId: string, callbackTabString: string) =>
  `${ACOMPANHAMENTO_TERRITORIO_PATH}/visualizarImovel/${imovelId}/${getCallbackTabByString(callbackTabString)}`

export const createImovelNotFoundError = (source: string, imovelId: string): Error =>
  new Error(`[${source}] Inconsistencia de dados: imovel nao encontrado para o id ${imovelId}.`)
